import { CSSProperties } from 'react';
import { cn } from '../../../lib/utils';

/**
 * CategoryBadge — subtle inline pill for content categories, placed beside a
 * serif title (e.g. inside StopCard / HighlightCard). No dot, no colour.
 */
export interface CategoryBadgeProps {
  label: string;
  className?: string;
  style?: CSSProperties;
}

export function CategoryBadge({ label, className, style }: CategoryBadgeProps) {
  return (
    <span
      className={cn(className)}
      style={{
        display: 'inline-block', verticalAlign: 'middle',
        fontFamily: 'var(--font-sans)', fontSize: 'var(--fs-badge)', fontWeight: 500,
        color: 'var(--text-soft)', background: 'var(--surface)',
        border: '1px solid var(--line)', borderRadius: 'var(--r-pill)',
        padding: '2px 8px', whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {label}
    </span>
  );
}

export default CategoryBadge;
